import router from './index'
import store from '../store'
import { Message } from 'element-ui'
import { Auth } from '@/utils/auth'
import NProgress from 'nprogress' // progress bar

// 不需要携带token即可访问的路由组
const whiteList = ['/login', '/404']

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {

	const hasToken = Auth.getToken()

	if (hasToken) {
		if (to.path === '/login') {
			next()
		} else {
			// console.log(hasGetUserInfo,joinStatus,'666')

			/*if (hasGetUserInfo && joinStatus===1) {
				// historyKeyword.save(to.meta.title,to.fullPath)
				const fatherMenuPermission = store.getters.fatherMenuPermission || []
				const childrenMenuPermission = store.getters.childrenMenuPermission || []

				if (to && to.meta && to.meta.authFlag) {
					// console.log(to, "to")

					if (fatherMenuPermission.includes(to.meta.authFlag) || childrenMenuPermission.includes(to.meta.authFlag)) {
						next()
					} else {
						const routes = router.options.routes
						const _result = routes.find(item => {
							if (item.meta) {
								return item.meta.authFlag === fatherMenuPermission[0]
							}
						})
						if (_result) {
							next(`${_result.path}/${_result.children[0].path}`)
							NProgress.done()
							return
						}

						next('/403')
						NProgress.done()
					}
				} else {
					next();
				}
			} else {
				try {
					// historyKeyword.save(to.meta.title,to.fullPath)
					// get user info
					await store.dispatch('user/getInfo').then(() => {
						if (store.getters.join_in_status!==1){
							// window.open(OFFICE_LOCATION_URL, '_self')
							next(`/login?redirect=${to.path}`)
							NProgress.done()
							return
						}
						const fatherMenuPermission = store.getters.fatherMenuPermission || []
						const childrenMenuPermission = store.getters.childrenMenuPermission || []
						if (to && to.meta && to.meta.authFlag) {
							if (fatherMenuPermission.includes(to.meta.authFlag) || childrenMenuPermission.includes(to.meta.authFlag)) {
								next()
							} else {

								const routes = router.options.routes
								const _result = routes.find(item => {
									if (item.meta) {
										return item.meta.authFlag === fatherMenuPermission[0]
									}
								})

								if (_result) {
									next(`${_result.path}/${_result.children[0].path}`)
									NProgress.done()
									return
								}

								next(`/403`)
							}
						} else {
							next();
						}
					})
				} catch (error) {
					// remove token and go to login page to re-login
					// await store.dispatch('user/resetToken')
					Message.error(error || 'Has Error')
					NProgress.done()
				}
			}*/

			next()
			// next('/login')

		}
	} else {
		if (to.path === '/login') {
			next()
		}else {
			next('/login')
		}

		// if (whiteList.includes(to.path)) {
		// 	next()
		// } else {
		// 	next('/home')
		// }
	}
})

router.afterEach(() => {
})
